import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActionOwner, ActionOwnerData } from '../actions.model';
import { ActionOwnerApi } from './action-owner-api.token';

@Injectable({ providedIn: 'root' })
export class UnresolvedActionOwnerService implements ActionOwnerApi {
  loadOwners(): Observable<ActionOwnerData> {
    return of({
      owners: [],
      dependencyMessage:
        'The live Financial Assistant ID and display-name source is not available yet.',
    });
  }

  resolveOwner(): Observable<ActionOwner | null> {
    return of(null);
  }
}
